module.exports = __webpack_public_path__ + "img/ing.99e148c.png";